<script>
export default {
  name: "SingleContentsWrapper",
  props: {
    contentLink: {
      default: null,
    },
  },
  data() {
    return {
      content: {}
    }
  },
  methods: {},
  render() {
    return this.$scopedSlots.default({
      content: this.content.data.data,
    });
  },
  async mounted() {

    if (this.contentLink == null) {
      this.content = await this.$store.dispatch("Content/getContentWithoutState", this.$route.params.slug)
    } else {
      this.content = await this.$store.dispatch("Content/getContentWithoutState", this.contentLink)
    }

  },
}
</script>
